import { useState } from 'react';

// this func use for user setting modal have is working check box
const useIsWorking = ({
  defaultData,
  requiredKeys,
}: {
  defaultData: any;
  requiredKeys: Array<string>;
}) => {
  const [isWorking, setIsWorking] = useState<'on' | 'off'>(
    defaultData
      ? !defaultData?.endDate &&
        requiredKeys.every((key: string) => !!defaultData[key])
        ? 'on'
        : 'off'
      : 'off'
  );

  return {
    isWorking,
    setIsWorking,
  };
};

export default useIsWorking;
